import { FC } from 'react';
import { PulloverSelect, withStyles, MaterialSymbol } from 'vopay';
import { useTranslation } from 'react-i18next';
import styles from './LanguageSwitcher.module.scss';

const cn = withStyles(styles);

const LanguageSwitcher: FC = () => {
  const { i18n } = useTranslation('translations', { keyPrefix: 'BankConnection' });
  const languageOptions = {
    en: 'En',
    fr: 'Fr',
  };

  return (
    <div className={cn('container')}>
      <MaterialSymbol icon="translate" size="16px" color="rgba(45, 45, 45, 0.75)" />
      <PulloverSelect
        value={i18n.language === 'fr-CA' ? 'fr' : i18n.language}
        onChange={(value) => {
          void i18n.changeLanguage(value || 'en');
        }}
        align="end"
      >
        {Object.entries(languageOptions).map(([key, value]) => (
          <PulloverSelect.Option key={key} value={key}>
            {value}
          </PulloverSelect.Option>
        ))}
      </PulloverSelect>
    </div>
  );
};

export default LanguageSwitcher;
